"use client"
// PhotoSwipeGallery.js
import React from "react";
import dynamic from 'next/dynamic';

import "photoswipe/dist/photoswipe.css";

const LoadableGallery = dynamic(
  () => import("react-photoswipe-gallery").then(mod => ({ default: mod.Gallery })),
  { ssr: false }
);

const LoadableItem = dynamic(
  () => import("react-photoswipe-gallery").then(mod => ({ default: mod.Item })),
  { ssr: false }
);

function PhotoswipeGallery({ photos, withCaption = true, options }) {
  return (
    <LoadableGallery withCaption={withCaption} options={options}>
      {photos.map((photo, index) => (
        <LoadableItem
          key={index}
          original={photo.src}
          thumbnail={photo.thumbnail}
          width={photo.width}
          height={photo.height}
          title={photo.caption}
        >
          {({ ref, open }) => (
            <img
              ref={ref}
              onClick={open}
              src={photo.thumbnail}
              alt={photo.caption || ""}
              style={{
                maxWidth: "480px",
                maxHeight: "270px",
                objectFit: "contain",
                objectPosition: "center",
                width: "100%",
                borderRadius: "0.75rem",
                cursor: "pointer",
                backgroundColor: "#f3f4f6",
                cursor: "pointer"
              }}
            />
          )}
        </LoadableItem>
      ))}
    </LoadableGallery>
  );
}

export default PhotoswipeGallery;
